<template>
  <client-only>
    <div class="star-rating text-gray-600">
      <p v-if="!hideTitle" class="o-heading-2 text-center mb-5" v-text="$t(title)" />
      <div class="mt-9 flex flex-col justify-center">
        <OSvg v-if="!hideIcon" class="w-10 h-auto mx-auto" svg="google" />
        <div class="flex items-center justify-center my-rem">
          <div class="star-rating-stars flex justify-center" :class="{ 'md:mr-5': hideTitle }">
            <OSvg v-for="number in 5" :key="number" :svg="getStar(number)" class="mr-1" />
          </div>
        </div>
      </div>
      <div v-if="!hideStatistics" class="flex justify-center mt-3 md:mt-0 mb-9">
        <div class="ota-small-light md:ota-body-light">
          <span v-text="$t('HomePage.Rating', { count: rating })" />
          <span class="mx-1" v-text="'|'" />
          <span class="underline cursor-pointer" @click="$emit('click')" v-text="$tc('HomePage.ReviewsAmount', reviews )" />
        </div>
      </div>
    </div>
  </client-only>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'StarRating',
  components: {
    OSvg
  },
  props: {
    rating: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
      default: 'HomePage.CustomerReviews'
    },
    reviews: {
      type: String,
      default: '0'
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    hideStatistics: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStar (index) {
      if (this.rating >= index) {
        return 'star'
      }

      if (this.rating < index && this.rating > index - 1) {
        return 'star-half'
      }

      return 'star-empty'
    }
  }
}
</script>

<style lang="postcss" scoped>
.star-rating-stars {
  svg, path {
    height: 2.1rem;
  }
}

@screen md {
  .star-rating-stars {
    svg, path {
      height: 2.4rem;
    }
  }
}
</style>
